import * as signalR from "@microsoft/signalr";
import { AppLayout } from "../../../layouts";
import { Buttton, Cards, Header, Sides } from "../../../components";
import { Col, Container, ListGroup, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { ChatWindows } from "../../../commonPage";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor } from "../../../redux/actions";
import { useTranslation } from "react-i18next";
import { PiCalendar } from "react-icons/pi";

const ChatWithDoctor = ({ loginData }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();
    const chat = location.state?.chat;
    const [connection, setConnection] = useState();
    const [chatAppointmentDetails, setChatAppointmentDetails] = useState([]);
    const [chatHistory, setChatHistory] = useState([]);
    const joinChat = async (userGuid, message, appointmentGuid) => {
        if (connection) {
            const newEntry = {
                appointmentGuid: appointmentGuid,
                doctorGuid: chat.doctorGuid,
                patientGuid: userGuid,
                userType: loginData.userType,
                message: message,
                doctorImageUrl:
                    "https://fra1.digitaloceanspaces.com/internal.exado.eu/ProfileImage/default-avatar.png",
                patientImageUrl:
                    "https://fra1.digitaloceanspaces.com/internal.exado.eu/ProfileImage/default-avatar.png",
                isChatHistory: true,
                createdDate: new Date().toISOString(),
            };
            setChatHistory((prevChatHistory) => [...prevChatHistory, newEntry]);
            await connection
                .invoke("SendMessage", userGuid, message, appointmentGuid)
                .then(function () { })
                .catch(function (err) {
                    return console.error(err.toString());
                });
        }
    };
    useEffect(() => {
        let isMounted = true;
        const newConnection = new signalR.HubConnectionBuilder()
            .withUrl("https://api.internal.exado.eu/chatHub", {
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets,
            })
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Information)
            .build();

        const startConnection = async () => {
            try {
                await newConnection.start();
                if (!isMounted) return;

                console.log("SignalR Connected");
                setConnection(newConnection);

                await newConnection.invoke("updateConnectedId", loginData.userGuid);

                newConnection.on(
                    "ReceiveMessage",
                    (userGuid, message, appointmentGuid, userType) => {
                        const newMessage = {
                            appointmentGuid,
                            doctorGuid: chat.doctorGuid,
                            patientGuid: userGuid,
                            message,
                            userType,
                            doctorImageUrl:
                                "https://fra1.digitaloceanspaces.com/internal.exado.eu/ProfileImage/default-avatar.png",
                            patientImageUrl:
                                "https://fra1.digitaloceanspaces.com/internal.exado.eu/ProfileImage/default-avatar.png",
                            isChatHistory: true,
                            createdDate: new Date().toISOString(),
                        };

                        setChatHistory((prevChatHistory) => [...prevChatHistory, newMessage]);
                    }
                );
            } catch (err) {
                console.error("SignalR Connection Error: ===", err);
            }
        };

        startConnection();

        return () => {
            isMounted = false;
            newConnection.off("ReceiveMessage");
            newConnection
                .stop()
                .then(() => console.log("SignalR Disconnected"))
                .catch((err) => console.error("Error disconnecting SignalR:", err));
        };
    }, [chat.doctorGuid, loginData.userGuid]);

    useEffect(() => {
        let credentials = {
            appointmentGuid: chat.appointmentGuid,
            DoctorGuid: chat.doctorGuid,
            PatientGuid: loginData.userGuid,
            Currency: "EUR",
            LanguageId: loginData.languageId,
            RequestTimeZone: loginData.timeZoneId,
            IsChatHistory: true,
        };
        dispatch(actionDoctor.postGetChatHistory(credentials));
    }, [chat.appointmentGuid, chat.doctorGuid, dispatch, loginData.languageId, loginData.timeZoneId, loginData.userGuid]);
    const postGetChatHistoryData = useSelector((state) => state.doctor.postGetChatHistoryData?.data);

    useEffect(() => {
        if (postGetChatHistoryData?.result?.chatHistory) {
            setChatHistory(postGetChatHistoryData?.result?.chatHistory)
            setChatAppointmentDetails(postGetChatHistoryData?.result?.chatAppointmentDetails)
        }

    }, [postGetChatHistoryData])


    const rightSide = (
        <Container
            fluid
            className={`exado-container1 doctor-chats doctor-chat-with-patient`}
        >
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage
                        pageHeading={`${t("chat_room_with")} ${chat.patientName}`}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col className="d-flex justify-content-between align-items-center">
                    <h3 className="flex-grow-1 exado-title-three cwp-name">
                        {chat.patientName}
                    </h3>
                    {/* <Buttton.Buttton
                        children={t("diagnosis_reports")}
                        // onClick={() => handleSubmit(credentials)}
                        className="btn-border-Aqua_Teal"
                    /> */}
                    {/* <Buttton.Buttton
                        children={t("view_profile")}
                        // onClick={() => handleSubmit(credentials)}
                        className="btn-solid-Aqua_Teal"
                    /> */}
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col md={4}>
                    <Cards.Cardd
                        header={
                            <>
                                <div className="blkIcon">
                                    <PiCalendar className="header-Icn" />
                                </div>
                                <h5 className="exado-title-seven card-header-text">
                                    {t("appointment")} {t("Information")}
                                </h5>
                            </>
                        }
                        content={
                            <ListGroup className="card-content-list">
                                <ListGroup.Item>
                                    <label className="card-list-lable">{t("date")} :</label>
                                    <p className="exado-title-six">
                                        {new Date(chatAppointmentDetails[0]?.appointmentDate)
                                            .toLocaleDateString("en-US", {
                                                month: "short",
                                                day: "numeric",
                                                year: "numeric",
                                            })
                                            .replace(",", "th,")}
                                    </p>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <label className="card-list-lable">{t("time")} :</label>
                                    <p className="card-list-content exado-title-six">
                                        {new Date(
                                            chatAppointmentDetails[0]?.appointmentDate
                                        ).toLocaleTimeString("en-US", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        })}
                                    </p>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <label className="card-list-lable">
                                        {t("booking_id")} :{" "}
                                    </label>
                                    <p className="card-list-content exado-title-six">
                                        {chatAppointmentDetails[0]?.chatBookingId}
                                    </p>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <label className="card-list-lable">
                                        {t("consultation_fee")} :{" "}
                                    </label>
                                    <p className="card-list-content exado-title-six">
                                        {chatAppointmentDetails[0]?.chatFees +
                                            " " +
                                            chatAppointmentDetails[0]?.appointmentCurrency}
                                    </p>
                                </ListGroup.Item>
                            </ListGroup>
                        }
                        className="cardd cwp-card"
                    />
                </Col>
                <Col md={8}>
                    <Cards.Cardd
                        header={
                            <>
                                <div className="blkIcon">
                                    <PiCalendar className="header-Icn" />
                                </div>
                                <h5 className="exado-title-seven card-header-text">
                                    {t("appointment")} {t("details")}
                                </h5>
                            </>
                        }
                        content={
                            <ul className="pd-ul">
                                <li className="pd-li exado_body_text_three">
                                    Q: {t("patient_Details.since_when_symptoms_are_active")}
                                </li>
                                <li className="pd-li exado_body_text_three pd-li-ans">
                                    A: {chatAppointmentDetails[0]?.sinceWhen}
                                </li>
                                <li className="pd-li exado_body_text_three">
                                    Q: {t("patient_Details.is_any_medication_or_treatment_taken")}
                                </li>
                                <li className="pd-li exado_body_text_three pd-li-ans">
                                    A: {chatAppointmentDetails[0]?.anyMedication}
                                </li>
                                <li className="pd-li exado_body_text_three">
                                    Q: {t("patient_Details.has_diagnosis_been_given")}
                                </li>
                                <li className="pd-li exado_body_text_three pd-li-ans">
                                    A: {chatAppointmentDetails[0]?.diagnosisGiven}
                                </li>
                                <li className="pd-li exado_body_text_three">
                                    Q: {t("patient_Details.describe_problem_or_symptoms")}
                                </li>
                                <li className="pd-li exado_body_text_three pd-li-ans">
                                    A: {chatAppointmentDetails[0]?.symptoms}
                                </li>
                            </ul>
                        }
                        footer={
                            <Buttton.Buttton
                                className="btn-solid-Aqua_Teal"
                                children={t("consult")}
                            // onClick={() => setShowModal(true)}
                            />
                        }
                        className="cardd cwp-card"
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col md={12}>
                    <ChatWindows

                        loginData={loginData}
                        chatHistory={chatHistory}
                        joinChat={joinChat}
                        chat={chat}
                        displayName={chat.doctorName}
                    />
                </Col>
            </Row>
        </Container>
    );
    return (
        <AppLayout.AppLayoutOne
            leftSide={<Sides.LeftSides loginData={loginData} />}
            rightSide={rightSide}
        />
    );
};

export default ChatWithDoctor;
